module.exports = __webpack_public_path__ + "img/dateEle.2451fb66.svg";